import { erpAxios } from '.';

const setGenerisanUgovorPolja = async (data) => {
  const res = await erpAxios.post(`/statusZahtjevaPolja/setGenerisanUgovorPolja`, data);
  return res;
};

export default setGenerisanUgovorPolja;
